import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useStateValue } from "../../StateProvider";
import { Home, Store, ShoppingCart, Package, User } from "lucide-react";
import "./MobileFooter.css";

export default function MobileFooter() {
  const [{ cart, user }] = useStateValue();
  const location = useLocation();
  const totalItems = cart.reduce((t, i) => t + i.quantity, 0);

  const path = location.pathname;

  // Don't show on auth/checkout flows
  const hideRoutes = [
    "/checkout",
    "/thank-you",
    "/live-chat",
    "/login",
    "/signup",
    "/auth/verify",
    "/account/reset-password",
    "/account/change-password",
    "/account/verify-email",
    "/account/email-verification",
  ];
  if (hideRoutes.some((r) => path.startsWith(r))) return null;

  const active =
    path === "/"
      ? "home"
      : path.startsWith("/shop")
        ? "shop"
        : path === "/cart"
          ? "cart"
          : path.startsWith("/order")
            ? "orders"
            : path.startsWith("/account")
              ? "account"
              : path.startsWith("/product")
                ? ""
                : "";

  return (
    <>
      {/* Frosted blur fade - sits behind the nav, blurs content below it */}
      <div className="mf__fade" aria-hidden="true" />
      <nav className="mf" aria-label="App navigation">
        <Link
          to="/"
          className={`mf__tab${active === "home" ? " mf__tab--on" : ""}`}
        >
          <Home size={21} strokeWidth={active === "home" ? 2.6 : 1.8} />
          <span>Home</span>
        </Link>

        <Link
          to="/shop"
          className={`mf__tab${active === "shop" ? " mf__tab--on" : ""}`}
        >
          <Store size={21} strokeWidth={active === "shop" ? 2.6 : 1.8} />
          <span>Shop</span>
        </Link>

        {/* Cart - always green bubble */}
        <Link to="/cart" className="mf__tab mf__tab--cart">
          <div
            className={`mf__cart-bub${active === "cart" ? " mf__cart-bub--active" : ""}`}
          >
            <ShoppingCart size={22} color="#fff" strokeWidth={2.2} />
            {totalItems > 0 && (
              <span className="mf__cart-count">
                {totalItems > 9 ? "9+" : totalItems}
              </span>
            )}
          </div>
        </Link>

        <Link
          to="/orders"
          className={`mf__tab${active === "orders" ? " mf__tab--on" : ""}`}
        >
          <Package size={21} strokeWidth={active === "orders" ? 2.6 : 1.8} />
          <span>Orders</span>
        </Link>

        <Link
          to={user ? "/account" : "/login"}
          className={`mf__tab${active === "account" ? " mf__tab--on" : ""}`}
        >
          <User size={21} strokeWidth={active === "account" ? 2.6 : 1.8} />
          <span>{user ? "Account" : "Sign In"}</span>
        </Link>
      </nav>
    </>
  );
}
